/**
 * Header notification list for course and account events.
 */
import React from "react";
import { Box, Divider, Icon } from "@mui/material";
import { useTranslation } from "react-i18next";

import VText from "form/VText";
import { useAsterController } from "context";
import { getShortDate, getShortTime } from "utils/date";

/**
 * Renders stored notifications with type-specific copy.
 */
const HeaderAlert = () => {
  const { t } = useTranslation("common");

  const [controller] = useAsterController();
  const { notifications } = controller;

  return (
    <Box className="my-2">
      <VText className="text-2xl mx-4 font-bold">Notifications</VText>
      <Box sx={{ width: "100%", typography: "body1" }}>
        <Box value="1" className="w-80 p-4 v-light-scrollbar max-h-72 overflow-y-auto">
          {notifications.map((item) => (
            <Box key={`${item.time}${item.username}`}>
              <VText color="secondary" className="text-xs" div>
                <Icon className="text-xs">calendar_month</Icon>&nbsp;{getShortDate(item.time)} - {getShortTime(item.time)}
              </VText>
              <VText className="text-base">
                {item.type === "course_complete" && (
                  <>
                    <b>{item.fullname || item.username}</b> {t("has completed")} <b>{item.course}</b>
                  </>
                )}
                {item.type === "module_complete" && (
                  <>
                    <b>{item.fullname || item.username}</b> {t("has completed a module of")} <b>{item.course}</b>
                  </>
                )}
                {item.type === "course_assigned" && (
                  <>
                    <b>{item.course}</b> {t("has been assingned to")} <b>{item.fullname || item.username}</b>
                  </>
                )}
                {item.type === "user_registered" && (
                  <>
                    <b>{item.fullname || item.username}</b> {t("has been registered in our platform")}
                  </>
                )}
                {item.type === "password_changed" && (
                  <>
                    {t("Password of")} <b>{item.fullname || item.username}</b> {t("has been changed")}
                  </>
                )}
                {item.type === "physical_session_assign" && (
                  <>
                    {t("A physical session has been assingned to")} <b>{item.fullname || item.username}</b>
                  </>
                )}
              </VText>
              <Divider className="my-2 bg-gray-200 dark:v-bg-body" />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default HeaderAlert;
